import axiosClient from './axiosClient';

const centresApi = {
  create: (data) => {
    const url = '/course-centres';
    return axiosClient.post(url, data);
  },
  get: (params) => {
    const url = '/course-centres';
    return axiosClient.get(url, { params });
  },
  getById: (id) => {
    const url = `/course-centres/${id}`;
    return axiosClient.get(url);
  },
  delete: (id) => {
    const url = `/course-centres/${id}`;
    return axiosClient.delete(url);
  },
  edit: (id, data) => {
    const url = `/course-centres/${id}`;
    return axiosClient.put(url, data);
  },
  getCountry: (params) => {
    const url = '/course-centres/getCountries';
    return axiosClient.get(url, { params });
  },
  getState: (params) => {
    const url = `/course-centres/getStates`;
    return axiosClient.get(url, { params });
  },
  getCity: (params) => {
    const url = '/course-centres/getCities';
    return axiosClient.get(url, { params });
  },
  getCentresByIntake: (id) => {
    const url = `/intakes/get-course-centres-by-intake/${id}`;
    return axiosClient.get(url);
  },
  getAllCentresForUser: () => {
    const url = `/course-centres/get-all-centres`;
    return axiosClient.get(url);
  },
};

export default centresApi;
